import React, { useContext, useState } from 'react';
import { withApollo } from 'react-apollo';
import debounce from 'lodash/debounce';
import { GlobalSearchQueryV2 } from '../../../state/services/gql/search';
import WithTracking from './tracking';
import GlobalSearch from './component';
import { DEFAULT_TAGS } from './consts';
import AppContext from '../../../context';
import DiscoveryContext from '../../../contexts/discoveryContext/context';
import { ContextName } from '../../../appContext/contextName';
import {
  formatEvents,
  formatTags,
  formatDefaultTags,
  formatLocations,
} from './utils';

const GlobalSearchContainer = ({
  injected: {
    trackTagSearchClicked,
    trackEventSearchClicked,
    trackLocationSearchClicked,
    trackNearMeSearchClicked,
    trackShowAllClicked,
    trackInputEntered,
    trackPanelOpened,
    trackPanelClosed,
  },
  fetchData,
  router,
  ...props
}) => {
  const { searchParams, currentPath: lastTagPath } = useContext(
    DiscoveryContext,
  );

  const { countryCode, data = {} } = props;
  const { searchTags = {}, searchEventsV2 = {}, searchLocations = [] } = data;

  return (
    <GlobalSearch
      fetchData={fetchData}
      defaultTags={formatDefaultTags({
        tags: DEFAULT_TAGS(countryCode),
        searchParams,
      })}
      tags={formatTags({ tags: searchTags, searchParams })}
      events={formatEvents(searchEventsV2, countryCode)}
      locations={formatLocations({
        locations: searchLocations,
        path: lastTagPath,
        searchParams,
      })}
      trackEventSearchClicked={trackEventSearchClicked}
      trackTagSearchClicked={trackTagSearchClicked}
      trackLocationSearchClicked={trackLocationSearchClicked}
      trackNearMeSearchClicked={trackNearMeSearchClicked}
      trackInputEntered={trackInputEntered}
      trackPanelClosed={trackPanelClosed}
      trackPanelOpened={trackPanelOpened}
      trackShowAllClicked={trackShowAllClicked}
      {...props}
    />
  );
};

const GlobalSearchContainerWithGraphQL = ({ client, ...props }) => {
  const {
    [ContextName.LOCATION.LATITUDE]: latitude,
    [ContextName.LOCATION.LONGITUDE]: longitude,
    [ContextName.COUNTRY_CODE]: countryCode,
  } = useContext(AppContext);
  const [data, setData] = useState();

  const radius = 100;

  const fetchData = debounce(async (searchTerm) => {
    if (!searchTerm) return;

    const { data: queryData } = await client.query({
      query: GlobalSearchQueryV2,
      variables: {
        query: searchTerm,
        searchParameters: { resultsPerPage: 5, name: searchTerm },
        countryCode: countryCode?.toLowerCase(),
        latitude,
        longitude,
        radius,
        sessionToken: 'abcd', // TODO
      },
    });
    setData(queryData);
  }, 500);

  return (
    <GlobalSearchContainer
      {...props}
      data={data}
      fetchData={fetchData}
      countryCode={countryCode?.toLowerCase()}
    />
  );
};

export default WithTracking(withApollo(GlobalSearchContainerWithGraphQL));
